import React from 'react'
import VerifyEmail from '../components/EmailVerify/EmailVerify'

const VerifyEmailPage = () => {
  return (
    <div>
        <VerifyEmail />
    </div>
  )
}

export default VerifyEmailPage
